<template>
  <v-container fluid>
    <h2 class="mb-5">
      {{ prasymasTitle
      }}<el-tooltip
        inline
        :tooltip="`NtrPaslaugos. Šeima išregistravimas. Anotacija`"
        external
        @activate="
          eventPayload =>
            showAprasymas(
              eventPayload,
              'NtrPaslaugos. Šeima išregistravimas. Anotacija'
            )
        "
      />
    </h2>
    <div class="paslauga-aprasymas">
      <el-paslauga-aprasymas
        :tooltip="paslaugaAprasymas"
        @close="hideAprasymas"
      />
    </div>
    <el-paslauga-santrauka
      :tooltip="`NtrPaslaugos. Šeima išregistravimas. Santrauka`"
    />

    <v-card class="pa-0" flat>
      <el-overlay-loading :loading="pageloading" />

      <el-button
        v-if="showNaujasPrasymas && !showNaujasError"
        :loading="naujasPrasymasLoading"
        @click.native.stop="openPrasymasPagrindas()"
      >
        {{ $t('Pildyti dokumentą') }}
      </el-button>

      <el-savitarna-alert v-if="showNaujasError" dense outlined type="error">
        {{ naujasError }}
      </el-savitarna-alert>

      <el-savitarna-alert
        v-if="showWarningPrasymas"
        dense
        outlined
        type="error"
      >
        {{
          $t(
            'Juridinio fakto "Šeimos turto išregistravimas" negalimas, nes nei Jūsų, nei Jūsų sutuoktinio turtui nėra įregistruotas juridinis faktas "Šeimos turtas".'
          )
        }}
      </el-savitarna-alert>

      <prasymas-list-rengiami
        :key="rengiamiKey"
        :prasymas-tipas-filter="prasymasTipas"
        @loaded="rengiamiLoaded"
        @edit="editPrasymas"
        @updateList="updateList"
      />

      <prasymas-list-iregistruoti
        :prasymas-tipas-filter="prasymasTipas"
        :rengiami-length="rengiamiLength"
        :naujas-prasymas-title="$t('Išregistruoti')"
        @loaded="iregistruotiLoaded"
        @naujasPrasymas="naujasPrasymas"
        @prasymasPagrindas="openPrasymasPagrindas"
        :key="iregistruotiKey"
      />

      <modal-ntr-prasymas-pagrindas
        v-model="showPrasymasPagrindas"
        :prasymas-tipas-filter="prasymasTipas"
        @confirmPrasymasPagrindas="confirmPrasymasPagrindas"
        @cancelPrasymasPagrindas="cancelPrasymasPagrindas"
        :key="pagrindasKey"
      />
    </v-card>
  </v-container>
</template>

<script>
import prasymasList from '@/mixins/prasymasList'
import userRole from '../../mixins/userRole'
import PrasymasListRengiami from './PrasymasListRengiami'
import PrasymasListIregistruoti from './PrasymasListIregistruoti'
import ModalNtrPrasymasPagrindas from '../modals/ModalNtrPrasymasPagrindas'

export default {
  name: 'SeimaIsregistravimas',
  components: {
    PrasymasListRengiami,
    PrasymasListIregistruoti,
    ModalNtrPrasymasPagrindas,
  },
  mixins: [prasymasList, userRole],
  data() {
    return {
      search: null,
      prasymas: [],
      searchData: {},
    }
  },
  computed: {
    prasymasKodas() {
      return 'seima-isregistravimas'
    },
    showNaujasPrasymas() {
      return (
        this.rengiamiLength == 0 &&
        this.iregistruotiLength == 0 &&
        !this.pageloading
      )
    },
    showWarningPrasymas() {
      return (
        false &&
        this.rengiamiLength == 0 &&
        this.iregistruotiLength == 0 &&
        !this.pageloading
      )
    },
  },
  created() {
    this.loading = true
  },
  methods: {},
}
</script>
<style lang="scss" scoped></style>
